// extracted by mini-css-extract-plugin
export default {"listContainer":"TodoList_listContainer__5PPUb","listText":"TodoList_listText__qVC5y"};